import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safehtml.pipe';
import { SortPipe } from './sort.pipe';

const DIRECTIVES = [SafeHtmlPipe, SortPipe];

@NgModule({
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES]
})
export class NgcPipesModule {}
